import { InjectionToken } from '@angular/core';
import { IDocument } from '@pf/shared-common';
import { Observable } from 'rxjs';

export interface IDocumentImageGalleryService {
    previewUrl$(doc: IDocument, parentId?: string): Observable<string>;

    uploadImage$(
        parentId: string,
        file: File,
        options: { fileName: string }
    ): Observable<unknown>;

    deleteImage$(parentId: string, documentId: string): Observable<unknown>;

    setPrimaryImage$(parentId: string, documentId: string): Observable<unknown>;
}

export const DOCUMENT_IMAGE_GALLERY =
    new InjectionToken<IDocumentImageGalleryService>('DOCUMENT_IMAGE_GALLERY');
